<template>
  <div class="container">
    <header>
      <p>Hi there, my name is</p>
      <h1>Shahid Shaikh.</h1>
      <h2>I make things for the web</h2>
      <p >
        I'm a creative front‑end developer with 2+ years of professional
        experience, based in Mumbai. In my spare time I make illustrations on
        Codepen.
      </p>
      <a class="get-in-touch" href="mailto:shahid.sk27595@gmail.com">Get In Touch</a>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style>
</style>
